import { Card, CardContent, CardDescription, CardHeader } from "@loot-os/ui/components/card";

/** One headline number with its caption; the Overview, Revenue and Analytics pages share the shape. */
export function StatCard({ label, value }: { label: string; value: string }) {
  return (
    <Card className="gap-1 py-4">
      <CardHeader className="px-4">
        <CardDescription>{label}</CardDescription>
      </CardHeader>
      <CardContent className="px-4 text-2xl font-semibold tabular-nums">{value}</CardContent>
    </Card>
  );
}
